






import Vue from 'vue';
import Quizzes from '@/components/quizzes/Quizzes.vue';

export default Vue.extend({
  name: 'RapidTest',
  components: { Quizzes },
  data() {
    return {
      loading: true,
    };
  },
  async mounted(): Promise<void> {
    // todo
  },
  methods: {
  },
});
